<template>
  <div class="subpage main_area" style="position: relative; color: rgb(255, 255, 255) !important">
    <div class="subpage main_area">
      <div class="layout fullpage_white">
        <div class="promo_detail_page">
          <div class="promo_detail_content">
            <div class="title" style="padding-top: 20px">{{ dataInfo.title }}</div>
            <div class="title">{{ dataInfo.created_at }}</div>
            <div class="content" v-html="dataInfo.content"></div>
          </div>
        </div>
      </div>
    </div>
    <div v-if="$store.state.token && dataInfo.can_apply == 1" class="promo_category_items_name active" @click="amountShow = true">活动申请</div>
    <div style="height: 60px"></div>
    <!-- 填写申请金额 -->
    <van-dialog v-model="amountShow" title="活动申请" show-cancel-button :before-close="isOk" style="background: #fff !important" confirmButtonText="立即申请">
      <div style="padding: 10px;20px;background:rgb(251 248 248)!important">
        <van-cell-group>
          <van-field v-model="amount"  tyle="background:#fff!important" type="text" placeholder="请根据活动条件填写您能享受赠送的金额" oninput="value=value.replace(/[^0-9]/g,'')" />
        </van-cell-group>
      </div>
    </van-dialog>
  </div>
</template>
<script>
export default {
  name: 'discountInfo',
  data() {
    return { dataInfo: {}, amount: null, amountShow: false };
  },
  created() {
    let that = this;
    let query = that.$route.query;
    if (query.id) {
      that.getInfo(query.id);
    }
  },
  methods: {
    getInfo(id) {
      let that = this;
      that.$parent.showLoading();
      that.$apiFun.post('/api/activitydeatil', { id }).then(res => {
        console.log(res);
        if (res.code !== 200) {
          that.$parent.showTost(0, res.message);
        }
        if (res.code === 200) {
          that.dataInfo = res.data;
        }
        that.$parent.hideLoading();
      });
    },
    doactivityapply() {
      let that = this;
      that.$parent.showLoading();
      that.$apiFun.post('/api/doactivityapply', { activityid: that.dataInfo.id, amount: that.amount }).then(res => {
        that.$parent.hideLoading();
        that.$parent.showTost(1, res.message);
      });
    },
    isOk(action, done) {
      let that = this;
      if (action === 'confirm') {
        that.doactivityapply();
        done(true);
      } else {
        done(true);
      }
    },
  },
  mounted() {
    let that = this;
  },
  updated() {
    let that = this;
  },
  beforeDestroy() {},
};
</script>
<style lang="scss" >
.subpage span {
  background: none !important;
  background-color: none !important;
  color: #adadad !important;
}
.subpage p {
  background: none !important;
  background-color: none !important;
  color: #adadad !important;
}
.subpage div {
  background: none !important;
  background-color: none !important;
  color: #adadad !important;
}

.subpage {
  color: #adadad !important;
}
.subpage .promo_category_items_name {
  text-align: center;
  border-radius: var(--tab_game_radius);
  padding: 5px;
  color: var(--tab_game_txt_inactive);
  border: var(--tab_game_borderthick_inactive) solid var(--tab_game_border_inactive);
  -webkit-box-sizing: border-box;
  box-sizing: border-box;
  background: var(--tab_game_bg_inactive) !important;
  box-shadow: unset;
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
  width: 90%;
}
.subpage .promo_category_items_name.active {
  color: var(--tab_game_txt_active);
  margin: 0px auto;
  background: var(--tab_game_bg_active) !important;
  -webkit-box-shadow: 0px 4px 15px rgb(0 0 0 / 12%);
  box-shadow: 0px 4px 15px rgb(0 0 0 / 12%);
  border: var(--tab_game_border_active);
}
</style>



// WEBPACK FOOTER //
// src/components/mode/discountInfo.vue